import {
  TiptapBase,
  BulletList,
  ListItem,
  OrderedList,
  Bold,
  Italic,
  Underline,
  Strike,
  Link,
  History,
  AutoHideToolbar,
  ClearContent,
  UpdateContent,
  ToggleMessageControls,
  Placeholder,
} from '@/js/util/tiptap/extensions';

import { LinksHandlers, ListsHandlers, TextFormattingHandlers } from '@/js/util/tiptap/handlers';

const placeholder = 'Leave a message...';

export default class CompactConfig {
  get extensions() {
    const MessageTextPlaceholder = Placeholder[0].configure({ placeholder });

    return [
      ...TiptapBase,
      ...BulletList,
      ...ListItem,
      ...OrderedList,
      ...Bold,
      ...Italic,
      ...Underline,
      ...Strike,
      ...Link,
      ...History,
      ...AutoHideToolbar,
      ...ClearContent,
      ...UpdateContent,
      ...ToggleMessageControls,
      ...[MessageTextPlaceholder],
    ];
  }

  get handlers() {
    return {
      ...LinksHandlers,
      ...ListsHandlers,
      ...TextFormattingHandlers,
    };
  }
}
